var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox customer-order-pre" },
    [
      _c(
        "div",
        { staticClass: "search-panel" },
        [
          _c(
            "el-form",
            {
              staticClass: "search-form",
              attrs: { inline: true, model: _vm.tableFrom, size: "small" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "制卡批次号：" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入", clearable: "" },
                    model: {
                      value: _vm.tableFrom.batchNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.tableFrom, "batchNo", $$v)
                      },
                      expression: "tableFrom.batchNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "卡面名称：" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入", clearable: "" },
                    model: {
                      value: _vm.tableFrom.cardFaceName,
                      callback: function ($$v) {
                        _vm.$set(_vm.tableFrom, "cardFaceName", $$v)
                      },
                      expression: "tableFrom.cardFaceName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "卡号ID：" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入", clearable: "" },
                    model: {
                      value: _vm.tableFrom.cardNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.tableFrom, "cardNo", $$v)
                      },
                      expression: "tableFrom.cardNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "状态：" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择", clearable: "" },
                      model: {
                        value: _vm.tableFrom.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.tableFrom, "status", $$v)
                        },
                        expression: "tableFrom.status",
                      },
                    },
                    _vm._l(_vm.statusOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.label, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "可使用小程序：" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择",
                        clearable: "",
                        filterable: "",
                      },
                      model: {
                        value: _vm.tableFrom.availableProgram,
                        callback: function ($$v) {
                          _vm.$set(_vm.tableFrom, "availableProgram", $$v)
                        },
                        expression: "tableFrom.availableProgram",
                      },
                    },
                    _vm._l(_vm.programOptions, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.appName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "创建时间：" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetimerange",
                      "range-separator": "至",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                      "default-time": ["00:00:00", "23:59:59"],
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    model: {
                      value: _vm.createTimeRange,
                      callback: function ($$v) {
                        _vm.createTimeRange = $$v
                      },
                      expression: "createTimeRange",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "制卡时间：" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "datetimerange",
                      "range-separator": "至",
                      "start-placeholder": "开始时间",
                      "end-placeholder": "结束时间",
                      "default-time": ["00:00:00", "23:59:59"],
                      "value-format": "yyyy-MM-dd HH:mm:ss",
                    },
                    model: {
                      value: _vm.makeTimeRange,
                      callback: function ($$v) {
                        _vm.makeTimeRange = $$v
                      },
                      expression: "makeTimeRange",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { staticClass: "form-actions" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("搜索")]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.handleReset } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "has-permi",
                  rawName: "v-has-permi",
                  value: ["admin:order:customer:pre:add"],
                  expression: "['admin:order:customer:pre:add']",
                },
              ],
              staticClass: "make-card-btn",
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.handleMakeCard },
            },
            [_vm._v("制卡")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticClass: "pre-table",
          attrs: {
            data: _vm.tableData,
            size: "mini",
            border: "",
            "highlight-current-row": "",
            "header-cell-style": { fontWeight: "bold", color: "#303133" },
          },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "48" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "batchNo", label: "制卡批次号", "min-width": "105" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "cardFaceName",
              label: "卡面名称",
              "min-width": "90",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "可使用小程序", "min-width": "115" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.getProgramNames(scope.row))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "totalCount", label: "生成数量", width: "78" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "可分配数量", width: "88" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("span", [
                      _vm._v(_vm._s(_vm.getAvailableCount(scope.row))),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "cardNoRange",
              label: "卡号ID范围",
              "min-width": "96",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "卡面正面样式", width: "112" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "card-preview front" },
                      [
                        scope.row.frontStyleUrl
                          ? _c("el-image", {
                              staticClass: "card-image",
                              attrs: {
                                src: scope.row.frontStyleUrl,
                                fit: "contain",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.openImagePreview(
                                    scope.row.frontStyleUrl
                                  )
                                },
                              },
                            })
                          : _c("span", [
                              _vm._v(_vm._s(scope.row.cardFaceName)),
                            ]),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "卡面背面样式", width: "112" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "card-preview back" },
                      [
                        scope.row.backStyleUrl
                          ? _c("el-image", {
                              staticClass: "card-image",
                              attrs: {
                                src: scope.row.backStyleUrl,
                                fit: "contain",
                              },
                              nativeOn: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.openImagePreview(
                                    scope.row.backStyleUrl
                                  )
                                },
                              },
                            })
                          : _c("span", [
                              _vm._v(_vm._s(scope.row.cardFaceName)),
                            ]),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "status", label: "状态", width: "86" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      {
                        class: [
                          "status-text",
                          _vm.getStatusClass(scope.row.status),
                        ],
                      },
                      [_vm._v(_vm._s(_vm.getStatusText(scope.row.status)))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "remark", label: "备注", "min-width": "82" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "creator", label: "创建人", width: "82" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "createTime",
              label: "创建时间",
              "min-width": "116",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "makeTime", label: "制卡时间", "min-width": "116" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              width: "128",
              fixed: "right",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "table-actions" },
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "has-permi",
                                rawName: "v-has-permi",
                                value: ["admin:order:customer:pre:detail"],
                                expression:
                                  "['admin:order:customer:pre:detail']",
                              },
                            ],
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDetail(scope.row)
                              },
                            },
                          },
                          [_vm._v("\n            详情\n          ")]
                        ),
                        _vm._v(" "),
                        [0, 1].includes(Number(scope.row.status))
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:order:customer:pre:update"],
                                    expression:
                                      "['admin:order:customer:pre:update']",
                                  },
                                ],
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n            编辑\n          ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        Number(scope.row.status) === 0
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:order:customer:pre:make"],
                                    expression:
                                      "['admin:order:customer:pre:make']",
                                  },
                                ],
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleMake(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n            已制卡\n          ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        Number(scope.row.status) === 0
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["admin:order:customer:pre:delete"],
                                    expression:
                                      "['admin:order:customer:pre:delete']",
                                  },
                                ],
                                staticClass: "delete-action",
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDelete(scope.row)
                                  },
                                },
                              },
                              [_vm._v("\n            删除\n          ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        [0, 1].includes(Number(scope.row.status))
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: [
                                      "admin:order:customer:pre:download",
                                    ],
                                    expression:
                                      "['admin:order:customer:pre:download']",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                  size: "mini",
                                  disabled: _vm.isDownloadTaskRunning(
                                    scope.row
                                  ),
                                  loading: _vm.isDownloadTaskRunning(scope.row),
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDownload(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.getDownloadButtonText(scope.row)
                                    ) +
                                    "\n          "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-pagination", {
        staticClass: "pagination",
        attrs: {
          "current-page": _vm.tableFrom.page,
          "page-size": _vm.tableFrom.limit,
          "page-sizes": [10, 20, 50, 100],
          layout: "total, sizes, prev, pager, next",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _vm._v(" "),
      _c("MakeCardDialog", {
        ref: "MakeCardDialogRef",
        attrs: { "program-options": _vm.programOptions },
        on: { submit: _vm.handleMakeCardSubmit },
      }),
      _vm._v(" "),
      _c("EditCardDialog", {
        ref: "EditCardDialogRef",
        attrs: { "program-options": _vm.programOptions },
        on: { submit: _vm.handleEditSubmit },
      }),
      _vm._v(" "),
      _c("DetailCardDialog", {
        ref: "DetailCardDialogRef",
        attrs: {
          "fu-card-options": _vm.fuCardOptions,
          "program-options": _vm.programOptions,
        },
      }),
      _vm._v(" "),
      _vm.imagePreviewVisible
        ? _c("el-image-viewer", {
            staticClass: "customer-order-pre-image-viewer",
            attrs: {
              "url-list": _vm.imagePreviewList,
              "z-index": 99999,
              "on-close": _vm.closeImagePreview,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }